import { render, staticRenderFns } from "./0018.vue?vue&type=template&id=ffc088d8&scoped=true&"
import script from "./0018.vue?vue&type=script&lang=js&"
export * from "./0018.vue?vue&type=script&lang=js&"
import style0 from "./0018.vue?vue&type=style&index=0&id=ffc088d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc088d8",
  null
  
)

export default component.exports